/**
 * @generated SignedSource<<6d597f42cf47e9dd842034e5fb2aea7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LearnableKind = "Course" | "GroupCoaching" | "MicroLearning" | "OneToOneCoaching";
export type learnableGridRefetchQuery$variables = {
  after?: string | null;
  before?: string | null;
  filterByCompleted?: boolean | null;
  first?: number | null;
  kinds: ReadonlyArray<LearnableKind>;
  last?: number | null;
};
export type learnableGridRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"learnableGrid_LearnableFragment">;
};
export type learnableGridRefetchQuery = {
  response: learnableGridRefetchQuery$data;
  variables: learnableGridRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "before"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "filterByCompleted"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "kinds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "last"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v3 = {
  "kind": "Variable",
  "name": "filterByCompleted",
  "variableName": "filterByCompleted"
},
v4 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v5 = {
  "kind": "Variable",
  "name": "kinds",
  "variableName": "kinds"
},
v6 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v7 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v4/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "typeDefinition",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "extension",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isUnlockNecessaryToStart",
                  "storageKey": null
                }
              ],
              "type": "LearnContentExtensionImpl",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "LearnAsyncContentTypeDefinition",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressPercentage",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headContentId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTaxFree",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "netPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v10/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deGrossPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "atGrossPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "chGrossPrice",
              "storageKey": null
            }
          ],
          "type": "AcademiesProductExtension",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "licenseAvailability",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numAvailable",
          "storageKey": null
        }
      ],
      "type": "LicenseAvailabilityFreeLicensesAvailable",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v23 = [
  (v20/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "extension",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "unlockInfo",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v10/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstContentId",
                  "storageKey": null
                }
              ],
              "type": "UnlockInfoDemo",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diploma",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AcademiesTagData",
              "kind": "LinkedField",
              "name": "data",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isClickable",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isTopic",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "extension",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isMicroLearning",
                  "storageKey": null
                },
                (v22/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContractPartner",
                  "kind": "LinkedField",
                  "name": "contractPartner",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContractPartnerData",
                      "kind": "LinkedField",
                      "name": "data",
                      "plural": false,
                      "selections": (v23/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "PublishedConstellationRootExtensionExtension",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PublishedRootExtensionImpl",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v25 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CoachingOfferDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": [
      (v20/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "tags",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AcademiesTagData",
            "kind": "LinkedField",
            "name": "data",
            "plural": false,
            "selections": (v23/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "image",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbnail",
            "storageKey": null
          },
          (v13/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      (v21/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "setting",
    "plural": false,
    "selections": [
      (v8/*: any*/),
      (v10/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CoachProfile",
    "kind": "LinkedField",
    "name": "associatedCoaches",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "coach",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      (v9/*: any*/)
    ],
    "storageKey": null
  },
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "learnableGridRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "learnableGrid_LearnableFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "learnableGridRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerJourneyQueries",
        "kind": "LinkedField",
        "name": "CustomerJourney",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "Dashboard",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": "SortedLearnablesConnection",
                "kind": "LinkedField",
                "name": "sortedLearnables",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SortedLearnablesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnableWithLastUpdated",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "learnable",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isPublishedLearnable"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "root",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "structureDefinition",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v16/*: any*/),
                                              (v17/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "viewerTreeState",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  (v10/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v18/*: any*/),
                                                      (v19/*: any*/)
                                                    ],
                                                    "type": "IsStartedViewerTreeState",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v24/*: any*/)
                                            ],
                                            "type": "LearnOpportunityRootStructureDefinition",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedCourseLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "root",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "structureDefinition",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v16/*: any*/),
                                              (v17/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "viewerTreeState",
                                                "plural": false,
                                                "selections": [
                                                  (v8/*: any*/),
                                                  (v10/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      (v18/*: any*/)
                                                    ],
                                                    "type": "IsStartedViewerTreeState",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              (v24/*: any*/)
                                            ],
                                            "type": "LearnOpportunityRootStructureDefinition",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedMicroLearningLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoachingOffer",
                                    "kind": "LinkedField",
                                    "name": "groupCoaching",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedGroupCoachingLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoachingOffer",
                                    "kind": "LinkedField",
                                    "name": "oneToOneCoaching",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedOneToOneCoachingLearnable",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastUpdated",
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v7/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "learnableGrid_sortedLearnables",
                "kind": "LinkedHandle",
                "name": "sortedLearnables"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a46e2d9a5eac1d311bf42cd1ee48ffcd",
    "id": null,
    "metadata": {},
    "name": "learnableGridRefetchQuery",
    "operationKind": "query",
    "text": "query learnableGridRefetchQuery(\n  $after: String = null\n  $before: String = null\n  $filterByCompleted: Boolean = false\n  $first: Int = null\n  $kinds: [LearnableKind!]!\n  $last: Int = null\n) {\n  ...learnableGrid_LearnableFragment_4CLuFR\n}\n\nfragment coachingLearnableCard_PublishedLearnableFragment on PublishedLearnable {\n  __isPublishedLearnable: __typename\n  ... on PublishedGroupCoachingLearnable {\n    kind\n    id\n    groupCoaching {\n      id\n      description {\n        name\n        description\n        shortDescription\n        tags {\n          __typename\n          id\n          data {\n            name\n          }\n        }\n        image {\n          thumbnail\n          url\n          id\n        }\n        product {\n          ...offerCard_ProductFragment\n          id\n        }\n      }\n      setting {\n        __typename\n        kind\n      }\n      associatedCoaches {\n        coach {\n          name\n          id\n        }\n        id\n      }\n      licenseAvailability {\n        __typename\n        ... on LicenseAvailabilityFreeLicensesAvailable {\n          numAvailable\n        }\n      }\n    }\n  }\n  ... on PublishedOneToOneCoachingLearnable {\n    kind\n    id\n    oneToOneCoaching {\n      id\n      description {\n        name\n        description\n        shortDescription\n        tags {\n          __typename\n          id\n          data {\n            name\n          }\n        }\n        image {\n          thumbnail\n          url\n          id\n        }\n        product {\n          ...offerCard_ProductFragment\n          id\n        }\n      }\n      setting {\n        __typename\n        kind\n      }\n      associatedCoaches {\n        coach {\n          name\n          id\n        }\n        id\n      }\n      licenseAvailability {\n        __typename\n        ... on LicenseAvailabilityFreeLicensesAvailable {\n          numAvailable\n        }\n      }\n    }\n  }\n}\n\nfragment educationalOfferCard_PublishedCourseLearnableFragment on PublishedLearnable {\n  __isPublishedLearnable: __typename\n  ... on PublishedCourseLearnable {\n    id\n    kind\n    root {\n      id\n      description\n      shortDescription\n      image {\n        url\n        id\n      }\n      typeDefinition {\n        __typename\n        ... on LearnAsyncContentTypeDefinition {\n          extension {\n            __typename\n            ... on LearnContentExtensionImpl {\n              isUnlockNecessaryToStart\n            }\n          }\n        }\n      }\n      structureDefinition {\n        __typename\n        ... on LearnOpportunityRootStructureDefinition {\n          progressPercentage\n          title\n          viewerTreeState {\n            __typename\n            kind\n            ... on IsStartedViewerTreeState {\n              startedAt\n              headContentId\n            }\n          }\n          extension {\n            __typename\n            ... on PublishedRootExtensionImpl {\n              unlockInfo {\n                __typename\n                kind\n                ... on UnlockInfoDemo {\n                  firstContentId\n                }\n              }\n              diploma\n              tags {\n                __typename\n                id\n                kind\n                data {\n                  name\n                  isClickable\n                  isTopic\n                }\n              }\n              product {\n                ...offerCard_ProductFragment\n                id\n              }\n              extension {\n                __typename\n                ... on PublishedConstellationRootExtensionExtension {\n                  isMicroLearning\n                  licenseAvailability {\n                    __typename\n                    ... on LicenseAvailabilityFreeLicensesAvailable {\n                      numAvailable\n                    }\n                  }\n                  contractPartner {\n                    id\n                    data {\n                      name\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ... on PublishedMicroLearningLearnable {\n    id\n    kind\n    root {\n      id\n      description\n      shortDescription\n      image {\n        url\n        id\n      }\n      typeDefinition {\n        __typename\n        ... on LearnAsyncContentTypeDefinition {\n          extension {\n            __typename\n            ... on LearnContentExtensionImpl {\n              isUnlockNecessaryToStart\n            }\n          }\n        }\n      }\n      structureDefinition {\n        __typename\n        ... on LearnOpportunityRootStructureDefinition {\n          progressPercentage\n          title\n          viewerTreeState {\n            __typename\n            kind\n            ... on IsStartedViewerTreeState {\n              headContentId\n              startedAt\n            }\n          }\n          extension {\n            __typename\n            ... on PublishedRootExtensionImpl {\n              unlockInfo {\n                __typename\n                kind\n                ... on UnlockInfoDemo {\n                  firstContentId\n                }\n              }\n              diploma\n              tags {\n                __typename\n                id\n                kind\n                data {\n                  name\n                  isClickable\n                  isTopic\n                }\n              }\n              product {\n                ...offerCard_ProductFragment\n                id\n              }\n              extension {\n                __typename\n                ... on PublishedConstellationRootExtensionExtension {\n                  isMicroLearning\n                  licenseAvailability {\n                    __typename\n                    ... on LicenseAvailabilityFreeLicensesAvailable {\n                      numAvailable\n                    }\n                  }\n                  contractPartner {\n                    id\n                    data {\n                      name\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment learnableGrid_LearnableFragment_4CLuFR on Query {\n  CustomerJourney {\n    Dashboard(kinds: $kinds, filterByCompleted: $filterByCompleted) {\n      sortedLearnables(first: $first, last: $last, before: $before, after: $after) {\n        edges {\n          node {\n            learnable {\n              __typename\n              id\n              kind\n              __isPublishedLearnable: __typename\n              ...educationalOfferCard_PublishedCourseLearnableFragment\n              ...coachingLearnableCard_PublishedLearnableFragment\n            }\n            lastUpdated\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n          hasPreviousPage\n          startCursor\n        }\n      }\n    }\n  }\n}\n\nfragment offerCard_ProductFragment on Product {\n  isTaxFree\n  netPrice\n  extensions {\n    __typename\n    kind\n    ... on AcademiesProductExtension {\n      deGrossPrice\n      atGrossPrice\n      chGrossPrice\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd00b1746d79486578644c21d4c49e45";

export default node;
